import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgChevronRight(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.7322 15.9999L9.73218 6.99994L11.4999 5.23218L21.3838 15.1161C21.6183 15.3505 21.75 15.6684 21.75 16C21.75 16.3315 21.6183 16.6494 21.3838 16.8838L11.4999 26.7677L9.73218 24.9999L18.7322 15.9999Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
